export default __webpack_public_path__ + "static/media/logo-dark.9da350e6.png";